'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Item = require('./Item.js');
var Menu_module = require('./Menu.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * A multi level menu
 */
const Menu = ({ items, currentItem = '', onItemSelected = () => undefined, isCurrentItem = (selectedItem, item) => selectedItem === item.label, }) => {
    const itemClicked = (url) => () => {
        if (onItemSelected) {
            onItemSelected(url);
        }
    };
    function fetchCurrentChildren(selectedItem, children, currentChildren) {
        if (children !== undefined && currentChildren.length === 0) {
            for (let i = 0; i < children.length; i += 1) {
                const menuItem = children[i];
                if (isCurrentItem(selectedItem, menuItem)) {
                    currentChildren.push(menuItem);
                    break;
                }
                fetchCurrentChildren(selectedItem, menuItem.children, currentChildren);
            }
        }
    }
    function hasCurrentChildren(selectedItem, children) {
        const currentChildren = [];
        fetchCurrentChildren(selectedItem, children, currentChildren);
        return currentChildren.length > 0;
    }
    const getMenuItemNode = (selectedItem) => function generateItem(item, index) {
        const { children, component, url, label } = item;
        const hasChildren = children !== undefined && children.length > 0;
        const isCurrent = isCurrentItem(selectedItem, item);
        const hasCurrentSub = hasCurrentChildren(selectedItem, children);
        let className = '';
        if (hasCurrentSub) {
            className = Menu_module["default"].hasCurrentSub;
        }
        else if (hasChildren) {
            className = Menu_module["default"].hasSub;
        }
        else if (isCurrent) {
            className = Menu_module["default"].current;
        }
        return (React__default["default"].createElement("li", { className: className, key: index },
            component || React__default["default"].createElement(Item["default"], { onClick: itemClicked(url) }, label),
            hasChildren && children ? (React__default["default"].createElement("ul", null, children.map(getMenuItemNode(selectedItem)))) : ('')));
    };
    return (React__default["default"].createElement("div", { className: Menu_module["default"].leftMenuMultiLevel },
        React__default["default"].createElement("ul", null, items.map(getMenuItemNode(currentItem)))));
};

exports["default"] = Menu;
